import router from "@/router";

const DocMenuConfig = [
  {
    pages: [
      {
        heading: "Menu_Dashboard",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/general/home.svg",
        fontIcon: "bi-app-indicator",
      },
      {
        heading: "Menu_CompanyPage",
        route: "/company",
        svgIcon: "media/icons/duotune/general/company.svg",
        fontIcon: "bi-archive",
        permissions: "ManageMyCompany",
      },
    ],
  },

  {
    heading: "menu_system_admin",
    route: "/admin/template",
    pages: [
      {
        heading: "Menu_Companies",
        route: "/companyList",
        svgIcon: "media/icons/duotune/general/companies.svg",
        fontIcon: "bi-archive",
        permissions: "ManageCompanies",
      },
      {
        heading: "menu_item_template",
        route: "/admin/template/list",
        svgIcon: "media/icons/duotune/general/templates.svg",
        fontIcon: "bi-archive",
        permissions: "ManageChecklistTemplates",
      },
      {
        heading: "menu_item_template_questions",
        route: "/admin/template/questions/list",
        svgIcon: "media/icons/duotune/general/question.svg",
        fontIcon: "bi-layers",
        permissions: "ManageChecklistTemplates",
      },
      {
        heading: "menu_item_template_answers",
        route: "/admin/template/answertemplates/list",
        svgIcon: "media/icons/duotune/general/template.svg",
        fontIcon: "bi-layers",
        permissions: "ManageChecklistTemplates",
      },

      {
        heading: "menu_item_template_category",
        route: "/admin/template/categories/list",
        svgIcon: "media/icons/duotune/general/category.svg",
        fontIcon: "bi-layers",
        permissions: "ManageChecklistTemplates",
      },
      {
        heading: "menu_item_template_sections",
        route: "/admin/template/sections/list",
        svgIcon: "media/icons/duotune/general/department.svg",
        fontIcon: "bi-layers",
        permissions: "ManageChecklistTemplates",
      },
    ],
  },

  {
    heading: "Menu_Customer_Definition",
    route: "/admin",
    pages: [
      {
        heading: "Customers",
        route: "/admin/customers",
        svgIcon: "media/icons/duotune/general/customer.svg",
        fontIcon: "bi-layers",
        permissions: "ManageCustomers",
      },
      {
        heading: "Locations",
        route: "/admin/locations",
        svgIcon: "media/icons/duotune/general/location.svg",
        fontIcon: "bi-layers",
        permissions: "ManageLocations",
      },
      {
        heading: "Menu_List_Projects",
        route: "/admin/projects",
        svgIcon: "media/icons/duotune/general/project.svg",
        fontIcon: "bi-layers",
        permissions: "ManageProjects",
      },
      {
        heading: "Menu_Add_Service",
        route: "/admin/operations",
        svgIcon: "media/icons/duotune/general/activity.svg",
        fontIcon: "bi-layers",
        permissions: "ManageOperationTypes",
      },
    ],
  },

  {
    heading: "Menu_Users",
    route: "/admin",
    pages: [
      {
        heading: "Menu_Users_UserListPage",
        route: "/admin/users",
        svgIcon: "media/icons/duotune/general/user.svg",
        fontIcon: "bi-layers",
        permissions: "ManageUsers",
      },
      {
        heading: "Menu_Users_UserRoleListPage",
        route: "/admin/user-roles",
        svgIcon: "media/icons/duotune/general/userrole.svg",
        fontIcon: "bi-layers",
        permissions: "ManageUserGroups",
      },
    ],
  },

  {
    heading: "Menu_Audit",
    route: "/audit",
    pages: [
      {
        heading: "Menu_Audits",
        route: "/auditlist",
        svgIcon: "media/icons/duotune/general/plan.svg",
        fontIcon: "bi-layers",
        permissions: "ManageAuditPlans",
      },
      {
        heading: "Menu_Actions",
        route: "/auditactions",
        svgIcon: "media/icons/duotune/general/actions.svg",
        fontIcon: "bi-layers",
        permissions: "ManageAuditActions",
      },
      {
        heading: "Menu_Analysis",
        route: "/analysis",
        svgIcon: "media/icons/duotune/general/analysis.svg",
        fontIcon: "bi-layers",
        permissions: "ManageAuditAnalysis",
      },
    ],
  },

  {
    heading: "Menu_Checklists_Items",
    route: "/checklistitems",
    pages: [
      {
        heading: "menu_item_template",
        route: "/templates",
        svgIcon: "media/icons/duotune/general/templates.svg",
        fontIcon: "bi-archive",
        permissions: "ManageChecklists",
      },
      {
        heading: "Menu_Audit_Checklist",
        route: "/checklists",
        svgIcon: "media/icons/duotune/general/check.svg",
        fontIcon: "bi-layers",
        permissions: "ManageChecklists",
      },
      {
        heading: "Menu_Audit_Questions",
        route: "/questions",
        svgIcon: "media/icons/duotune/general/question.svg",
        fontIcon: "bi-layers",
        permissions: "ManageQuestions",
      },
      {
        heading: "Menu_Audit_Answers_Template",
        route: "/answer-templates",
        svgIcon: "media/icons/duotune/general/template.svg",
        fontIcon: "bi-layers",
        permissions: "ManageAnswerTemplates",
      },

      {
        heading: "Menu_Audit_Categories",
        route: "/categorys",
        svgIcon: "media/icons/duotune/general/category.svg",
        fontIcon: "bi-layers",
        permissions: "ManageCategories",
      },
      {
        heading: "Menu_Audit_Departments",
        route: "/sections",
        svgIcon: "media/icons/duotune/general/department.svg",
        fontIcon: "bi-layers",
        permissions: "ManageDepartments",
      },
    ],
  },
];

export default DocMenuConfig;
